// SPDX-License-Identifier: AGPL-3.0-or-later
export const STREAM_PREVIEW_MAX_BYTES = 1000000;
export const STREAM_PREVIEW_MAX_DIMENSION_PX = 640;
export const STREAM_PREVIEW_MIN_DIMENSION_PX = 160;
export const STREAM_PREVIEW_INITIAL_UPLOAD_INTERVAL_MS = 1000;
export const STREAM_PREVIEW_INITIAL_UPLOAD_MAX_ATTEMPTS = 10;
export const STREAM_PREVIEW_UPLOAD_INTERVAL_MS = 4 * 60 * 1000;
export const STREAM_PREVIEW_UPLOAD_JITTER_MS = 60 * 1000;
export const STREAM_PREVIEW_REFRESH_INTERVAL_MS = 5000;
export const STREAM_PREVIEW_CONTENT_TYPE_JPEG = 'image/jpeg';
export const STREAM_PREVIEW_JPEG_DATA_URL_PREFIX = 'data:image/jpeg;base64,';
export const STREAM_PREVIEW_JPEG_QUALITY_START = 0.7;
export const STREAM_PREVIEW_JPEG_QUALITY_MIN = 0.4;
export const STREAM_PREVIEW_JPEG_QUALITY_STEP = 0.15;
export const STREAM_PREVIEW_DIMENSION_SCALE_STEP = 0.8;
export const STREAM_PREVIEW_ENCODE_ATTEMPTS = 6;
export const STREAM_AUDIO_PREFS_TTL_MS = 6 * 60 * 60 * 1000;
export const STREAM_AUDIO_PREFS_PRUNE_INTERVAL_MS = 10 * 60 * 1000;
export const STREAM_AUDIO_PREFS_TOUCH_INTERVAL_MS = 5 * 60 * 1000;
